import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import MessagingHub from '../../components/Succession/Messaging/MessagingHub';
import SuccessionThemeProvider from '../../components/Succession/SuccessionThemeProvider';
import Navbar from '../../components/StudentPlatform/Navbar';
import ApolloWrapper from './ApolloWrapper';
import getMessages from '../../lib/i18n/getMessages';

const StudentMessagesContainerInner = ({
  currentUser,
  conversationId,
  hiringPostId,
  brandLogoUrl,
  primaryColor,
  secondaryColor,
  accentColor,
  neutralColor,
}) => {
  console.log('[StudentMessagesContainer] Props received:');
  console.log('  currentUser:', currentUser);
  console.log('  currentUser.id:', currentUser?.id);
  console.log('  currentUser.name:', currentUser?.name);
  console.log('  conversationId:', conversationId);
  console.log('  hiringPostId:', hiringPostId);
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar
        currentUser={currentUser}
        currentPath="/student/messages"
        brandLogoUrl={brandLogoUrl}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Messages</h1>
          <p className="text-gray-600 mt-2">Connect with financial advisors</p>
        </div>
        
        <div 
          className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg"
          style={{ height: 'calc(100vh - 280px)' }}
        >
          <SuccessionThemeProvider theme="light">
            <MessagingHub 
              currentUser={currentUser}
              theme="light"
              initialConversationId={conversationId}
              initialHiringPostId={hiringPostId}
            />
          </SuccessionThemeProvider>
        </div>
      </div>
    </div>
  );
};

StudentMessagesContainerInner.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  conversationId: PropTypes.string,
  hiringPostId: PropTypes.string,
  brandLogoUrl: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  accentColor: PropTypes.string,
  neutralColor: PropTypes.string,
};

const StudentMessagesContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;

  return (
    <IntlProvider locale={locale} messages={getMessages(locale)}>
      <ApolloWrapper>
        <StudentMessagesContainerInner {...props} />
      </ApolloWrapper>
    </IntlProvider>
  );
};

StudentMessagesContainer.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  conversationId: PropTypes.string,
  hiringPostId: PropTypes.string,
  brandLogoUrl: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  accentColor: PropTypes.string,
  neutralColor: PropTypes.string,
};

export default StudentMessagesContainer;

